module.exports = __webpack_public_path__ + "static/avatar-90ba3bea2f3d1cb0bc07b2c10b51ccc2.png";